const HANDLER_KEY = '__clickOutsideHandler__'

const getCallback = (binding) => {
  const callback = binding?.value
  return typeof callback === 'function' ? callback : null
}

const removeListener = (el) => {
  const handler = el[HANDLER_KEY]
  if (!handler) return

  document.removeEventListener('click', handler, true)
  document.removeEventListener('touchstart', handler, true)
  delete el[HANDLER_KEY]
}

const addListener = (el, binding) => {
  removeListener(el)

  const callback = getCallback(binding)
  if (!callback) return

  const handler = (event) => {
    if (!el || el === event.target || el.contains(event.target)) return
    callback(event)
  }

  el[HANDLER_KEY] = handler

  document.addEventListener('click', handler, true)
  document.addEventListener('touchstart', handler, true)
}

export default {
  beforeMount (el, binding) {
    addListener(el, binding)
  },
  updated (el, binding) {
    addListener(el, binding)
  },
  unmounted (el) {
    removeListener(el)
  }
}
